import { defineMessage } from "react-intl";

export const strChannelsTitle = defineMessage({
  id: "Insights Channels page title",
  defaultMessage: "Channels",
});

export const strChannelsHint = defineMessage({
  id: "Insights Channels summary hint",
  defaultMessage: "Analyze your performance across all channels using last click attribution.",
});
